import { createFileRoute } from '@tanstack/react-router'
import { agreementTemplateSearchSchema } from '@/features/agreement-templates/filter-agreement-templates/model/agreementTemplateSearch'
import { AgreementTemplatesPage } from '@/pages/agreement-templates/ui/AgreementTemplatesPage'

export const Route = createFileRoute('/agreement-templates')({
  validateSearch: agreementTemplateSearchSchema,
  component: AgreementTemplatesPage,
})
